const WORDS = [
  "WEB DEVELOPMENT",
  "AI & VOICE AGENTS",
  "DIGITAL MARKETING",
  "AUTOMATION",
  "ENTREPRENEURSHIP",
];

export default function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <section
      data-testid="marquee-section"
      className="relative z-30 overflow-hidden border-y border-white/10 bg-[#050505] py-8 md:py-16"
    >
      <div className="flex w-max animate-marquee gap-6 whitespace-nowrap will-change-transform md:gap-8">
        {row.map((w, i) => (
          <div key={i} className="flex items-center gap-6 md:gap-8">
            <span className="font-display text-[14vw] leading-none text-stroke md:text-[9vw]">
              {w}
            </span>
            <span className="font-display text-[14vw] leading-none text-[#10b981] md:text-[9vw]">
              *
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
